webpackJsonp([63642485605921],{

/***/ 202:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _gatsbyLink = __webpack_require__(50);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _stylesModule = __webpack_require__(300);
	
	var _stylesModule2 = _interopRequireDefault(_stylesModule);
	
	var _BuyButton = __webpack_require__(133);
	
	var _BuyButton2 = _interopRequireDefault(_BuyButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArchiveItem = function (_Component) {
	  _inherits(ArchiveItem, _Component);
	
	  function ArchiveItem() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ArchiveItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.onEnter = function () {
	      var _this$props = _this.props,
	          onOver = _this$props.onOver,
	          slug = _this$props.slug;
	
	      onOver(slug);
	    }, _this.onLeave = function () {
	      var _this$props2 = _this.props,
	          onLeave = _this$props2.onLeave,
	          slug = _this$props2.slug;
	
	      onLeave(slug);
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ArchiveItem.prototype.render = function render() {
	    var _props = this.props,
	        attribution = _props.attribution,
	        buyLink = _props.buyLink,
	        client = _props.client,
	        description = _props.description,
	        dimensions = _props.dimensions,
	        material = _props.material,
	        medium = _props.medium,
	        slug = _props.slug;
	
	
	    var itemInfo = [client, medium, material, description, dimensions];
	    var items = itemInfo.filter(function (item) {
	      return !!item;
	    });
	
	    return _react2.default.createElement(
	      'div',
	      {
	        className: _stylesModule2.default.item,
	        id: slug
	      },
	      _react2.default.createElement(
	        'dl',
	        null,
	        items.map(function (info, index) {
	          return _react2.default.createElement(
	            'dt',
	            { key: '' + slug + info + index },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              {
	                className: _stylesModule2.default.info,
	                to: {
	                  pathname: '/' + slug,
	                  state: {
	                    showAll: true
	                  }
	                }
	              },
	              info
	            )
	          );
	        }),
	        attribution && _react2.default.createElement(
	          'dt',
	          {
	            key: 'attribution'
	          },
	          _react2.default.createElement(
	            'a',
	            { href: attribution.url, className: _stylesModule2.default.info },
	            attribution.label
	          )
	        ),
	        buyLink && _react2.default.createElement(
	          'dt',
	          {
	            className: _stylesModule2.default.buy,
	            key: 'buy'
	          },
	          _react2.default.createElement(_BuyButton2.default, {
	            link: buyLink
	          })
	        )
	      )
	    );
	  };
	
	  return ArchiveItem;
	}(_react.Component);
	
	ArchiveItem.propTypes = {
	  attribution: _propTypes2.default.object,
	  buyLink: _propTypes2.default.string,
	  client: _propTypes2.default.string,
	  description: _propTypes2.default.string,
	  dimensions: _propTypes2.default.string,
	  material: _propTypes2.default.string,
	  medium: _propTypes2.default.string,
	  onLeave: _propTypes2.default.func.isRequired,
	  onOver: _propTypes2.default.func.isRequired,
	  slug: _propTypes2.default.string
	};
	
	ArchiveItem.defaultProps = {
	  attribution: null,
	  buyLink: null,
	  client: '',
	  description: '',
	  dimensions: '',
	  material: '',
	  medium: '',
	  slug: ''
	};
	
	exports.default = ArchiveItem;
	module.exports = exports['default'];

/***/ }),

/***/ 300:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"item":"src-components-ArchiveItem----styles-module---item---bWgBD","info":"src-components-ArchiveItem----styles-module---info---c6Xqc"};

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Header = __webpack_require__(57);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ArchiveItem = __webpack_require__(202);
	
	var _ArchiveItem2 = _interopRequireDefault(_ArchiveItem);
	
	var _archiveModule = __webpack_require__(304);
	
	var _archiveModule2 = _interopRequireDefault(_archiveModule);
	
	var _getProjects = __webpack_require__(27);
	
	var _getProjects2 = _interopRequireDefault(_getProjects);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ArchivePage = function (_Component) {
	  _inherits(ArchivePage, _Component);
	
	  function ArchivePage() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, ArchivePage);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
	      backgroundIndex: 0,
	      currentProject: null
	    }, _this.onItemOver = function (slug) {
	      var data = _this.props.data;
	      var currentProject = _this.state.currentProject;
	
	      var projects = data.allContentfulProject.edges.map(function (_ref) {
	        var node = _ref.node;
	        return node;
	      });
	
	      _this.projectToEnter = slug;
	      if (!currentProject || slug !== currentProject.slug) {
	        var newProject = projects.find(function (project) {
	          return project.slug === slug;
	        });
	        _this.setState({
	          currentProject: newProject
	        });
	        _this.imageInterval = setInterval(function () {
	          _this.setState({
	            backgroundIndex: _this.state.backgroundIndex + 1
	          });
	        }, 400);
	      }
	    }, _this.onItemLeave = function (slug) {
	      _this.projectToEnter = null;
	
	      setTimeout(function () {
	        _this.shouldClear(slug);
	      }, 10);
	    }, _this.projectToEnter = null, _this.shouldClear = function (slug) {
	      if (!_this.projectToEnter || slug !== _this.projectToEnter) {
	        _this.setState({
	          backgroundIndex: 0,
	          currentProject: null
	        });
	        clearInterval(_this.imageInterval);
	      }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  ArchivePage.prototype.componentDidMount = function componentDidMount() {
	    var data = this.props.data;
	
	    // Preload images
	
	    if (data.allContentfulProject.edges) {
	      data.allContentfulProject.edges.forEach(function (project) {
	        var images = project.node.images;
	
	        if (images) {
	          images.forEach(function (image) {
	            var img = new Image();
	            img.src = image.asset.file.url;
	          });
	        }
	      });
	    }
	  };
	
	  ArchivePage.prototype.render = function render() {
	    var _this2 = this;
	
	    var data = this.props.data;
	    var _state = this.state,
	        backgroundIndex = _state.backgroundIndex,
	        currentProject = _state.currentProject;
	
	    var projects = (0, _getProjects2.default)(data.allContentfulProject.edges);
	    var projectImages = currentProject && currentProject.images;
	    var backgroundImage = projectImages && projectImages[backgroundIndex % projectImages.length];
	
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(_Header2.default, { background: !backgroundImage }),
	      _react2.default.createElement(
	        'div',
	        { className: _archiveModule2.default.imageWrapper },
	        backgroundImage && _react2.default.createElement('img', {
	          alt: backgroundImage.title,
	          key: backgroundImage.title,
	          src: backgroundImage.asset.file.url
	        })
	      ),
	      _react2.default.createElement(
	        'ul',
	        { className: _archiveModule2.default.list },
	        projects.map(function (project) {
	          return _react2.default.createElement(
	            'li',
	            { key: project.slug },
	            _react2.default.createElement(_ArchiveItem2.default, _extends({
	              onLeave: _this2.onItemLeave,
	              onOver: _this2.onItemOver
	            }, project))
	          );
	        })
	      )
	    );
	  };
	
	  return ArchivePage;
	}(_react.Component);
	
	ArchivePage.propTypes = {
	  data: _propTypes2.default.object.isRequired
	};
	
	exports.default = ArchivePage;
	var query = exports.query = '** extracted graphql fragment **';

/***/ }),

/***/ 304:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"imageWrapper":"src-pages----archive-module---imageWrapper---W5jEB","list":"src-pages----archive-module---list---4tiwP"};

/***/ }),

/***/ 27:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var INACTIVE = 'INACTIVE';
	
	function getProjects(edges) {
	  return edges.map(function (_ref) {
	    var node = _ref.node;
	    return node;
	  }).filter(function (node) {
	    return node.status !== INACTIVE;
	  });
	}
	
	exports.default = getProjects;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-archive-jsx-da14a79734c5853cf875.js